const items = document.querySelectorAll('.download-item');
items.forEach((item, index) => {
  const arr = [
    { text: 'macOS' },
    {  text: 'Windows' },
    { text: 'Google Play' },
    { text: 'iOS ＆ iPadOS' },
    { text: 'Android' },
    { text: 'Android TV' },
  ]
  // 鼠标移入事件
  item.addEventListener('mouseenter', function() {
    this.children[0].style.display = 'none'
    this.children[1].style.display = 'block'
    this.children[2].textContent = 'Download'
  });

  // 鼠标移出事件
  item.addEventListener('mouseleave', function() {
    this.children[0].style.display = 'block'
    this.children[1].style.display = 'none'
    this.children[2].textContent = arr[index].text
  });
});

const macOS = document.querySelector('#macos')
macOS.addEventListener('click', function() {
  const modal = document.querySelector('.macos-mask')
  modal.style.display = 'flex'
  modal.style.opacity = 1
})

const close = document.querySelector('.modal-close')
close.addEventListener('click', function() {
  const modal = document.querySelector('.macos-mask')
  modal.style.display = 'none'
  modal.style.opacity = 0
})
